import { render, staticRenderFns } from "./AdicionarGrupoNotificacaoDialog.vue?vue&type=template&id=3fd02d1b"
import script from "./AdicionarGrupoNotificacaoDialog.vue?vue&type=script&lang=js"
export * from "./AdicionarGrupoNotificacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports